import { jsx as _jsx } from "react/jsx-runtime";
import { ConnectButtonView } from '../Widget/WidgetNavigationView';
import useWallet from "../../hooks/useWallet";
import { useConnectModal } from "../Wallet/WalletModal";
const ConnectButton = ({ children, className, }) => {
    const { providers } = useWallet();
    const filteredProviders = providers.filter(p => !!p.autofillSupportedNetworks);
    const { connect } = useConnectModal();
    return (_jsx(ConnectButtonView, { onClick: async () => { await connect(); }, disabled: filteredProviders.length == 0, className: className, children: children }));
};
export default ConnectButton;
